<template>
  <PopupBase
    :show="show"
    :size="POPUP.Size.small"
    @close-pop-up="emit('close-pop-up')"
  >
    <div class="material-assistant-language-popup">
      <h5>{{ $tv('downloadDataSheet', 'ORingConfigurator') }}</h5>
      <p>{{ $tv('choseYourLanguage', 'ORingConfigurator') }}</p>
      <div class="form-group">
        <label
          id="language-select-label"
          for="language-select"
        >{{ $tv('LANGUAGE', 'globals') }}</label>
        <DropDown
          id="language-select"
          aria-labelledby="language-select-label"
          v-model="selectedLanguage"
          :items="languageOptions"
          :data-items="languageOptions"
          :text-field="'label'"
          :value-field="'value'"
          @change="handleLanguageChange"
        />
      </div>
      <div class="buttons flex-end">
        <ReactiveButton
          class="k-button k-button-solid-light"
          :theme-color="'secondary'"
          :loading="loading"
          :disabled="loading"
          @click="emit('download', selectedLanguage)"
        >
          {{ $tv('download', 'ORingConfigurator') }}
        </ReactiveButton>
      </div>
    </div>
  </PopupBase>
</template>

<script setup lang="ts">
import PopupBase from '@/components/popup/PopupBase.vue'
import ReactiveButton from '@/components/ReactiveButton.vue'
import DropDown from '@/components/input-components/DropDown.vue'
import useI18nExtended from '~/composables/usei18nExtended'
import {POPUP} from '~/assets/js/constants'

const emit = defineEmits(['close-pop-up', 'download', 'update:modelValue'])
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  modelValue: {
    type: String,
    default: 'en'
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const {tv: $tv} = useI18nExtended()

const languageOptions = [
  {value: 'en', label: $tv('LANGUAGE_EN', 'globals')},
  {value: 'de', label: $tv('LANGUAGE_DE', 'globals')}
]

// Use a simple ref for the dropdown selection
const selectedLanguage = ref(languageOptions.find(option => option.value === props.modelValue) || languageOptions[0])

// Watch for prop changes to update dropdown
watch(() => props.modelValue, (newValue) => {
  const foundOption = languageOptions.find(option => option.value === newValue)
  if (foundOption) {
    selectedLanguage.value = foundOption
  }
})

function handleLanguageChange(event: any) {
  const selectedValue = event.value || event.target?.value
  if (selectedValue) {
    // Update the selectedLanguage ref to the new selection
    const foundOption = languageOptions.find(option => option.value === selectedValue)
    if (foundOption) {
      selectedLanguage.value = foundOption
    }
    emit('update:modelValue', selectedValue)
  }
}
</script>

<style lang="scss">
.material-assistant-language-popup {
  label {
    display: block;
    font-weight: $base-text-font-weight-light;
    padding-bottom: .5rem;
  }

  .dropdown-wrapper {
    margin-bottom: 1rem;

    :deep(.k-dropdown .k-input) {
      font-weight: $base-text-font-weight-bold;
    }
  }
}
</style>
